import nacl from 'tweetnacl';
import Helpers from './Helpers';
import version from '../version';

export default class RequestBehaviour {
	/**
	 * Environment identifier (live|test|sandbox)
	 */
	env?: string = undefined;

	/**
	 * Transaction response messages language
	 */
	lang?: string = undefined;

	/**
	 * SDK indentifier type
	 */
	from?: string = undefined;

	/**
	 * SDK version
	 */
	sdk_version?: string = undefined;

	/**
	 * For internal use to prevent encrypting same request instance twice
	 */
	protected sdk_key_pair?: nacl.BoxKeyPair = undefined;

	/**
	 * Initialize request
	 */
	constructor() {
		this.lang = Intl.DateTimeFormat().resolvedOptions().locale;
		this.from = 'sdk-javascript';
		this.sdk_version = version;

		if (this.lang != 'es' && this.lang != 'en') {
			this.lang = 'es';
		}
	}

	/**
	 * Get sdk_key_pair from current instance
	 *
	 * @return
	 */
	getSDKKeyPair(): nacl.BoxKeyPair | undefined {
		return this.sdk_key_pair;
	}

	/**
	 * Check if current request needs encryption, must be overriden by inherited classes.
	 *
	 * @return
	 */
	isEncryptable(): boolean {
		return false;
	}

	/**
	 * Encrypt fields with sensitive data, must be overriden by inherited classes.
	 *
	 * @param publicKey
	 * @return
	 */
	withEncryption(publicKey?: string | null): string | null {
		return null;
	}


	/**
	 * Serialize object to JSON string
	 *
	 * @return
	 */
	toJson(): string {
		return Helpers.objectToJson(this, ['sdk_key_pair']);
	}
}
